(function () {
    'use strict';

    angular
        .module('employeeControllers')
        .controller('PendingEmployeeController', Controller);

    Controller.$inject = ['$scope', '$state', '$modal', 'employeeProfileService'];

    function Controller($scope, $state, $modal, employeeProfileService) {

        // Get Pending employee Infos
        employeeProfileService
            .getPendingEmployeeInfos($scope.employee.EmployeeID)
            .then(function (pendingEmpInfos) {
                $scope.empPendingInfos = pendingEmpInfos;
            });

        // Show Change Transfer Modal
        $scope.showChangeTransferModal = function () {

            var modalScope = $scope.$new(true);
            modalScope.empPendingInfos = $scope.empPendingInfos;
            modalScope.employee = $scope.employee;

            var changeTransferModal = $modal({
                scope: modalScope,
                template: require('./employeeSummary_OperationalTasks.ChangeTransferModal.tpl.html'),
                placement: 'center'
            });

            modalScope.hideModal = function () {
                changeTransferModal.$promise.then(changeTransferModal.hide);
            };

            modalScope.okModal = function () {
                modalScope.hideModal();
            };

            modalScope.changeTransfer = function () {

                employeeProfileService
                    .changePendingEmployee($scope.empPendingInfos)
                    .then(function () {
                        modalScope.hideModal();
                        $state.reload();
                    });
            };
        };
    }
})();
